import { LinearGradient, LinearGradientProps } from 'expo-linear-gradient';
import React from 'react';
import { StyleSheet, ViewStyle } from 'react-native';
import theme from 'theme';

type CustomSeparatorProps = Omit<LinearGradientProps, 'start' | 'locations' | 'colors'> & {
  style?: ViewStyle;
};

const Separator: React.FC<CustomSeparatorProps> = (props) => {
  const { style, ...restProps } = props;
  return (
    <LinearGradient
      {...restProps}
      style={[styles.separator, style]}
      locations={[0.1, 0.2, 1]}
      start={{ x: 0.1, y: 0.1 }}
      colors={['transparent', theme.colors.primary[600], 'transparent']}
    />
  );
};

const styles = StyleSheet.create({
  separator: {
    height: 1,
    opacity: 0.3,
  },
});

export default Separator;
